import React from 'react';
import t from '@zimpel/common/helpers/i18n';
import { H1 } from '@zimpel/common/components/Headlines';
import { ContentBody, ContentHeader, ContentNarrow } from '@zimpel/common/components/ContentLayout';

const PageNotFound: React.FC = () => (
  <>
    <ContentHeader>
      <ContentNarrow>
        <H1>{t('views.page_not_found.title')}</H1>
      </ContentNarrow>
    </ContentHeader>
    <ContentBody>
      <ContentNarrow>
        {t('views.page_not_found.body')}
      </ContentNarrow>
    </ContentBody>
  </>
);

export default PageNotFound;
